<template>
  <ProSpaceRightPanel v-if="!!record" :header="header" no-top-border>
    <template v-if="!!record" v-slot:center>
      <ProSpaceTabs :tabs="tabs">
        <template v-slot:tab-1>
          <ProSpacePanelBlock :header="headerChanges">
            <template v-slot:header> </template>
            <template v-slot>
              <ProSpacePanelBlockList
                :list="content"
                :itemsPerPage="itemsPerPage"
                :searched="true"
                :searchPlaceholder="$t('searchTxt')"
                type="row"
              />
            </template>
          </ProSpacePanelBlock>
        </template>
        <template v-slot:tab-2>
          <ProSpacePanelBlock :header="headerFields">
            <template v-slot:header> </template>
            <template v-slot>
              <ProSpacePanelBlockList
                :list="contentActual"
                :itemsPerPage="itemsPerPage"
                :searched="true"
                :searchPlaceholder="$t('searchTxt')"
                type="row"
              />
            </template>
          </ProSpacePanelBlock>
        </template>
      </ProSpaceTabs>
      <ProSpaceModal
        v-model="modalJSON"
        :title="$t('parameters')"
        icon="parameters"
        :applyTxt="false"
        :cancelTxt="$t('cancelTxt')"
      >
        <template v-slot:default>
          <ProSpaceGeoLayout>
            <template #center>
              <pre class="parameters-view">{{ paramsJSON }}</pre>
            </template>
          </ProSpaceGeoLayout>
        </template>
      </ProSpaceModal>
    </template>
  </ProSpaceRightPanel>
</template>

<script>
import {
  ProSpaceRightPanel,
  ProSpaceTabs,
  ProSpacePanelBlock,
  ProSpacePanelBlockList,
  ProSpaceModal,
  ProSpaceGeoLayout,
  // ProSpacePanelBlockItem,
} from "@prospace/prospace-components-library";
import { mapGetters } from "vuex";
export default {
  name: "HistoryPanel",
  components: {
    ProSpaceRightPanel,
    ProSpaceTabs,
    ProSpacePanelBlock,
    ProSpacePanelBlockList,
    ProSpaceModal,
    ProSpaceGeoLayout,
    // ProSpacePanelBlockItem,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
    historyService: {
      type: Object,
      required: true,
    },
    getActualName: {
      type: Function,
      required: true,
    },
    getActualId: {
      type: Function,
      required: true,
    },
    getActualStatus: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      tabs: [
        { s: "tab-1", name: this.$t("changes"), isActive: true },
        { s: "tab-2", name: this.$t("fields") },
      ],
      headerChanges: {
        title: "",
        isExpand: false,
      },
      headerFields: {
        title: "",
        isExpand: false,
      },
      modalJSON: false,
      paramsJSON: null,
    };
  },
  computed: {
    ...mapGetters({
      getFormatDateTimeSeconds: "userinfoStore/getFormatDateTimeSeconds",
    }),
    actualModel() {
      if (this.record && this.record.actualModel)
        return this.record.actualModel;
      return null;
    },
    previosValues() {
      if (this.record && this.record.previousValues)
        return this.record.previousValues;
      return null;
    },
    isReference() {
      let isPreviousReference = false;
      if (this.previosValues) {
        const keys = Object.keys(this.previosValues);
        if (keys.length === 1) {
          const s = keys[0].split("|");
          const rf = this.historyService.modelInfo.referenceFrom.find(
            (v) => v.modelName === s[0]
          );
          if (rf) isPreviousReference = true;
        }
      }
      return (
        this.record &&
        Array.isArray(this.record.groupIds) &&
        this.record.groupIds.length === 1 &&
        isPreviousReference
      );
    },
    itemsPerPage() {
      if (this.actualModel) return Object.keys(this.actualModel).length;
      return 1;
    },
    header() {
      if (this.actualModel) {
        return {
          title: this.getActualName(this.actualModel),
          id: this.getActualId(this.actualModel),
          status: this.getActualStatus(this.actualModel),
          options: [],
          showCounter: false,
        };
      }
      return {};
    },
    content() {
      if (this.previosValues) {
        let result = [];
        for (const key in this.previosValues) {
          if (this.historyService.modelInfo.systemProperties.includes(key))
            continue;
          let value = this.previosValues[key];
          if (this.isDate(key)) {
            value = this.getFormatDateTimeSeconds(value);
          } else if (this.isStr(key)) {
            value = this.formatStringValue(value);
          }
          let item = {
            title: key,
            originalName: key,
            text: value,
            underline: this.isReference,
          };
          let rf = this.referenceFieldConfs[key];
          // TODO проверить актуальность
          // if (rf) {
          //   if (rf.isKey) continue;
          //   item.title = rf.originalName;
          // }
          const preTitle = this.parseTitle(item.title);
          item.title = this.$t(preTitle);
          item.action = undefined;
          if (this.isReference) {
            item.action = () => {
              this.$emit("showReferenceChanges", key, this.record.groupIds[0]);
            };
          } else if (this.isStr(key) && this.isJSON(value)) {
            item.action = () => {
              this.showModalJSON(value);
            };
          }

          result.push([item]);
        }
        return result;
      }
      return [];
    },
    contentActual() {
      if (this.actualModel) {
        let result = [];
        for (const key in this.actualModel) {
          if (this.historyService.modelInfo.systemProperties.includes(key))
            continue;
          let value = this.actualModel[key];
          if (this.isDate(key)) {
            value = this.getFormatDateTimeSeconds(value);
          } else if (this.isStr(key)) {
            value = this.formatStringValue(value);
          }
          let item = {
            title: key,
            text: value,
          };
          // TODO проверить актуальность
          //let rf = this.referenceFieldConfs[key];
          // if (rf) {
          //   if (rf.isKey) continue;
          //   item.title = rf.originalName;
          // }
          const preTitle = this.parseTitle(item.title);
          item.title = this.$t(preTitle);
          item.action = undefined;
          if (this.isStr(key) && this.isJSON(value)) {
            item.action = () => {
              this.showModalJSON(value);
            };
            item.underline = true;
          }
          result.push([item]);
        }
        return result;
      }
      return [];
    },
    referenceFieldConfs() {
      return this.historyService.referenceFieldConfs();
    },
    fieldProperties() {
      return this.historyService.modelInfo?.properties;
    },
  },
  mounted() {},
  methods: {
    isDate(fieldName) {
      const prop = this.fieldProperties[fieldName];
      return prop === "DateTime" || prop === "DateTimeOffset";
    },
    isStr(fieldName) {
      const prop = this.fieldProperties[fieldName];
      return prop === "String";
    },
    isJSON(value) {
      try {
        const maybeJSON = JSON.parse(value);
        return maybeJSON && typeof maybeJSON === "object";
      } catch {
        return false;
      }
    },
    showModalJSON(value) {
      this.modalJSON = true;
      this.paramsJSON = JSON.stringify(JSON.parse(value), null, 2);
    },
    formatStringValue(value) {
      if (!value) {
        return;
      }
      return this.removeWhitespaceSymbols(this.removeHtmlTags(value));
    },
    removeHtmlTags(str) {
      return str.replace(/(<([^>]+)>)/gi, " ");
    },
    removeWhitespaceSymbols(str) {
      return str.replaceAll("&nbsp;", " ").replaceAll("&emsp;", " ");
    },
    parseTitle(title) {
      if (!title) return;

      const decap = ([first, ...rest]) => `${first.toLowerCase()}${rest.join('')}`;
      const cap = ([first, ...rest]) => `${_.capitalize(first)}${rest.join('')}`;
      const checker = (type) => this.$t(type) !== type ? this.$t(type) : null;

      let preTitle = this.historyService.modelName.split('ApiModel')[0];
      let resultTitle = preTitle;

      const typesTitle = {
        0: decap(title),
        1: decap(preTitle),
        2: _.camelCase(title),
        3: _.capitalize(title),
      };

      const comboTypesTitle = {
        decapTitle: typesTitle[0],
        comboTitle: typesTitle[1] + title,
        comboCamelPascalTitle: typesTitle[1] + typesTitle[3],
        comboCamelTitle: typesTitle[1] + typesTitle[2],
        comboCapCamelTitle: typesTitle[1] + cap(typesTitle[2])
      }

      for (let type in comboTypesTitle) {
        const t = comboTypesTitle[type];
        const res = checker(t);
        if(res) {
          resultTitle = res;
          break;
        } else {
          resultTitle = this.$t(title);
        }
      }
      return resultTitle;
    }
  },
};
</script>
